import { YesObject } from '@yes.technology/react-toolkit'
import api from '../../../utils/api'
import useInitialStatus from 'status/shared/hooks/useInitialStatus'

const idObjectClassStorageUrl = window.urlObjectclassUuid
const idObjectClassDocument = window.documentObjectclassUuid

type DocumentObject = YesObject & {
  url: YesObject[]
  content_type: string
}

type CreateOrUpdateParams = {
  uuid?: string
  des?: string
  complement?: string
  content_type?: string
  url?: string
}

type CreateOrUpdateResponse = {
  document?: DocumentObject
  statusDes?: string
  statusUuid?: string
}

const useDocument = () => {
  const initialStorageUrlStatus = useInitialStatus({
    objectclassUuid: idObjectClassStorageUrl
  })

  const initialDocumentStatus = useInitialStatus({
    objectclassUuid: idObjectClassDocument
  })

  const createOrUpdateDocument = async (
    documentData: CreateOrUpdateParams,
    showLoading: boolean = true
  ): Promise<CreateOrUpdateResponse> => {
    let url: YesObject[] | undefined = undefined

    if (documentData?.url && typeof documentData.url === 'string') {
      const payloadStorageUrl = {
        situation: window.activeSituationCode,
        uuid_status: initialStorageUrlStatus?.code,
        des: documentData.url,
        uuid_Objectclass: idObjectClassStorageUrl
      }
      const storageUrl = await api.postObjects(payloadStorageUrl, showLoading)
      url = [{ uuid: storageUrl?.uuid }] as YesObject[]
    }

    if (documentData?.uuid) {
      const response = await api.postObjectsFilter<DocumentObject>(
        {
          objectclass: idObjectClassDocument,
          query: {
            $and: [
              {
                'uuid.des': {
                  $eq: documentData.uuid
                }
              }
            ]
          },
          orderby: [],
          pagination: {
            limit: 1,
            offset: 0
          }
        },
        showLoading
      )

      const fetchedDocument = response.objects?.[0]

      if (!fetchedDocument)
        return {
          document: undefined,
          statusDes: undefined
        }

      await api.patchObjects<DocumentObject>(
        {
          uuid: documentData.uuid,
          uuid_Objectclass: idObjectClassDocument,
          version: fetchedDocument?.version,
          ...documentData,
          url: url || fetchedDocument.url
        },
        documentData?.uuid,
        showLoading
      )

      return {
        document: fetchedDocument,
        statusDes: initialDocumentStatus?.des,
        statusUuid: initialDocumentStatus?.uuid
      }
    }

    const payloadDocument = {
      situation: window.activeSituationCode,
      uuid_status: initialDocumentStatus?.code,
      uuid_Objectclass: idObjectClassDocument,
      ...documentData,
      url: url || []
    }

    const newDocument = await api.postObjects<DocumentObject>(
      payloadDocument,
      showLoading
    )

    return {
      document: newDocument,
      statusDes: initialDocumentStatus?.des,
      statusUuid: initialDocumentStatus?.uuid
    }
  }

  return {
    createOrUpdateDocument
  }
}

export default useDocument
